import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "First steps with OS X Lion",
  "description": "",
  "published": "2011-07-05T00:00:00.000Z",
  "redirect_from": ["/blog/first-steps-with-os-x-lion/swizec/1901"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A couple of days ago `}<a parentName="p" {...{
        "href": "http://www.apple.com",
        "title": "Apple"
      }}>{`Apple`}</a>{` released the GM version of `}<a parentName="p" {...{
        "href": "http://www.apple.com/macosx/lion",
        "title": "Mac OS X Lion"
      }}>{`OS X Lion`}</a>{` to developers. Yesterday I finally got around to installing it and trying it out. It often happens that this is the final version of a new OS that ends up on consumer's hard drives, but I don't think that's going to be the case this time 'round. In some ways the thing is almost as buggy as your average beta `}<a parentName="p" {...{
        "href": "http://www.ubuntu.com/",
        "title": "Ubuntu (operating system)"
      }}>{`Ubuntu`}</a>{` release.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/68za7.jpg",
        "alt": null
      }}></img></p>
    <p>{`Just a couple of things noticed since yesterday:`}</p>
    <ul>
      <li parentName="ul">{`@mihar couldn't login after update until he did a fresh install`}</li>
      <li parentName="ul">{`my sound died last night and was gone until I rebooted`}</li>
      <li parentName="ul">{`sometimes parts of the `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Graphical_user_interface",
          "title": "Graphical user interface"
        }}>{`GUI`}</a>{` don't refresh and there are left over glitches`}</li>
    </ul>
    <p>{`Actually that's not too bad, I really felt like I noticed more things than that ... guess I've grown a little bit spoiled. If this was Ubuntu I'd probably call it beyond ready for release and super awesome bug free and so on. But on a Mac it makes me want to bitch and moan.`}</p>
    <p>{`Oh us `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Spoiled_child",
        "title": "Spoiled child"
      }}>{`spoiled brats`}</a>{`.`}</p>
    <p>{`All in all, I have to say I really love the new features. Probably haven't discovered all of them and I don't want to look for spoilers in the keynote. It's much more fun just using the OS and being nicely delighted on every step of the way.`}</p>
    {
      /*more*/
    }
    <p>{`The general theme is: Make everything more `}<a parentName="p" {...{
        "href": "http://www.apple.com/ipad/",
        "title": "iPad"
      }}>{`iPad`}</a>{`-y.`}</p>
    <p>{`Actually, I'm going to make the rest of this post in screenshots and captions.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/68za7.jpg",
        "alt": null,
        "title": "This is simply the sexiest login screen ever"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/sNKpI.jpg",
        "alt": null,
        "title": "New Spaces will need some taking used to, but they sure look great. Better view of windows."
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/5zDNd.png",
        "alt": null,
        "title": "Apps now have history"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/7l8re.png",
        "alt": null,
        "title": "I guess the new dashboard made sense ... never used it much"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/9q4ii.jpg",
        "alt": null,
        "title": "The launchpad is a great feature for everyone not using Quicksilver"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/xfMzh.png",
        "alt": null,
        "title": "Airdrop looks pretty cool. So does the new sidebrowser in Finder"
      }}></img></p>
    <p>{`Another thing that I really really love are the new scrollbars, but I couldn't quite manage to make screenshots of it. Also the new mouse gestures are pretty fucking awesome. Too many of them to really list, but the one I think I'm going to appreciate the most is the three finger drag. No more awkward thumb action!`}</p>
    <p>{`Now all I need is a mac with an SSD because, to be honest, sometimes things feel a bit slow with all the state saving and things ... not to mention the whole "Keep windows open when reboot" that feature painfully needs an SSD.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://drayspencer.wordpress.com/2011/07/05/apple-to-allow-license-free-virtualization-with-os-x-lion-developers-roar-with-delight/"
        }}>{`Apple to allow license-free virtualization with OS X Lion, developers roar with delight`}</a>{` (drayspencer.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tidb.wordpress.com/2011/07/01/os-x-lion/"
        }}>{`OS X Lion`}</a>{` (tidb.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://writerway.com/2011/06/30/what-to-do-before-upgrading-your-mac-to-os-x-lion/"
        }}>{`What to do before upgrading your Mac to OS X Lion`}</a>{` (writerway.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://9to5mac.com/2011/07/01/os-x-lion-golden-master-seeded-to-developers/"
        }}>{`OS X Lion Golden Master seeded to developers ahead of July launch`}</a>{` (9to5mac.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.macstories.net/news/os-x-lion-gm-now-available/"
        }}>{`OS X Lion GM Now Available`}</a>{` (macstories.net)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=24dd1167-af88-4f12-a1b9-85557c32b7e7",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      